import React, {Component} from "react";
import styles from "./Disclaimer.module.scss";
import {Context} from "context";

export default class Disclaimer extends Component {
    static contextType = Context;

    render() {
        return (
            <div className={`${this.context.lightTheme ? "light" : "dark"} app`}>
                <div className={`bgTertiary highlightPrimary ${styles.disclaimer}`}>
                    <p>Disclaimer</p>
                    <p>{this.context.text.copy.disclaimer.p1}</p>
                    <p>{this.context.text.copy.disclaimer.p2}</p>
                    <button onClick={this.context.confirmDisclaimer} className="btn btnBrand">Continue</button>
                </div>
            </div>
        );
    }
}